import * as React from 'react'

/**
 * @description ShieldSafety icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ShieldSafety } from '@sravni/design-system-icons'
 *
 * <ShieldSafety />
 * ```
 */
export const ShieldSafety = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="ShieldSafety" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.273 9.27V8.149a1.273 1.273 0 0 0-2.545 0V9.27M11.458 9.271H8.541a.834.834 0 0 0-.833.834v1.77c0 .46.373.833.833.833h2.917c.46 0 .833-.373.833-.833v-1.77a.834.834 0 0 0-.833-.834Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.666 9.368c0 3.64-2.63 7.052-6.233 8.072-.282.08-.585.08-.867 0-3.602-1.02-6.233-4.432-6.233-8.072V6.011c0-.676.41-1.286 1.036-1.542l4.053-1.658a4.163 4.163 0 0 1 3.156 0l4.053 1.658a1.666 1.666 0 0 1 1.035 1.542v3.357Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
